import React from "react";
import { useLocation, useNavigate } from "react-router";
import { NavHashLink } from "react-router-hash-link";
import isologo from "../assets/ISO.webp";
import cybersecurity from "../assets/cybersecurity.png";
import { Link } from "react-router-dom";


const Footer = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const openInNewTab = (url: any) => {
    window.open(url, "_blank", "noreferrer");
  };

  const scrollWithOffset = (el: any) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = 0;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  const policyRoutes = [
    {
      label: "Privacy Policy",
      path: "/privacy-policy",
    },
    {
      label: "Social Media Policy",
      path: "/social-media-policy",
    },
    {
      label: "Whistleblower Policy",
      path: "/whistleblower-policy",
    },
    {
      label: "Modern Slavery Statement",
      path: "/modern-slavery-policy",
    },
    {
      label: "SMS Terms & Conditions",
      path: "/sms-terms-and-conditions"
    },
    {
      label: "SMS Opt-In",
      path: "/sms-opt-in"
    }
  ];
  // bg-red-600 sm:bg-yellow-600 md:bg-green-700 lg:bg-teal-600
  return (
    <div
      className={`footerContainer w-screen h-auto ${[
        "/privacy-policy",
        "/social-media-policy",
        "/whistleblower-policy",
        "/modern-slavery-policy",
      ].includes(location?.pathname)
        ? "hidden"
        : ""
        } md:h-max ${location?.pathname !== "/lp/mobile-app-development" &&
          location?.pathname !== "/lp/website-development"
          ? "lg:min-h-[400px]"
          : " lg:min-h-max px-5 py-7 lg:px-10 xl:px-20 lg:py-14"
        } pt-5 flex flex-col text-white bg-[#000000] `}
    >
      {location?.pathname !== "/lp/mobile-app-development" &&
        location?.pathname !== "/lp/website-development" ? (
        <div className="lg:mx-auto max-w-screen-2xl">
          <div className=" w-full h-14 flex justify-center items-center lg:hidden ">
            <svg
              className="flex-shrink-0 "
              width="135"
              height="22"
              viewBox="0 0 135 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M34.4902 8.82892H37.0563C38.9084 8.82892 39.3026 9.88512 39.3026 10.7777V19.9264H40.9241V10.1603C40.9241 8.16693 39.9274 7.23718 37.7852 7.23718H33.7687C31.6117 7.23718 30.6001 8.16693 30.6001 10.1603V19.9264H32.2216V10.7777C32.2141 9.89255 32.6158 8.82892 34.4902 8.82892Z"
                fill="#F15A29"
              />
              <path
                d="M43.0884 16.624C43.0884 17.8289 43.4157 18.6917 44.0925 19.2496C44.6206 19.6959 45.476 19.9264 46.6363 19.9264H53.5165V18.2752H47.0528C46.3165 18.2752 45.7958 18.1488 45.4685 17.881C44.9999 17.524 44.7619 16.9289 44.7619 16.1182V15.5083L53.5165 11.9454V10.4802C53.5165 8.26363 52.5347 7.23718 50.4297 7.23718H46.4132C44.1446 7.23718 43.0884 8.219 43.0884 10.324V16.624ZM44.7619 10.8669C44.7619 9.93718 45.1785 8.82892 47.1718 8.82892H49.6933C51.538 8.82892 51.8132 9.96693 51.8132 10.6512V11.0826L44.7619 13.9983V10.8669Z"
                fill="#F15A29"
              />
              <path
                d="M60.2332 7.2372H57.3101V2.52893H55.6812V19.9265H57.3101V8.82893H60.2332V7.2372Z"
                fill="#F15A29"
              />
              <path
                d="M71.8141 17.1074V15.4339C71.8141 14.638 71.5686 13.9983 71.0629 13.4702C70.5645 12.9496 69.9397 12.6892 69.1513 12.6892H66.1686C64.3835 12.6892 64.0116 11.7595 64.0116 10.9785V10.443C64.0116 9.91487 64.2496 9.46859 64.7108 9.15619C65.0306 8.94049 65.4918 8.82892 66.1091 8.82892H71.8067V7.23718H65.4918C64.562 7.23718 63.8777 7.40082 63.4612 7.72809C62.7397 8.29338 62.3901 8.99999 62.3901 9.89999V11.6851C62.3901 12.5107 62.6877 13.1504 63.305 13.6413C63.8703 14.1099 64.5992 14.3405 65.4769 14.3405H68.2959C69.4637 14.3405 70.1034 14.9504 70.1034 16.0438C70.1034 16.7876 70.0067 17.2934 69.8133 17.5983C69.5455 18.0446 69.0248 18.2752 68.2736 18.2752H62.3976V19.9264H68.8984C69.4488 19.9264 69.8653 19.8818 70.1331 19.8074C70.4381 19.7033 70.743 19.4727 71.048 19.1306C71.5686 18.5355 71.8141 17.8661 71.8141 17.1074Z"
                fill="#F15A29"
              />
              <path
                d="M78.5305 7.2372H75.6073V2.52893H73.9858V19.9265H75.6073V8.82893H78.5305V7.2372Z"
                fill="#F15A29"
              />
              <path
                d="M83.4175 9.01487C83.596 8.94049 83.9977 8.85123 85.3365 8.83636V7.23718H83.9531C81.7365 7.23718 80.7026 8.27107 80.7026 10.4802V19.9264H82.3241V11.0752C82.3241 9.98925 82.6886 9.29751 83.4175 9.01487Z"
                fill="#F15A29"
              />
              <path
                d="M97.9515 10.2942C97.9515 8.21156 96.873 7.23718 94.5523 7.23718H87.4937V8.82892H94.2399C95.073 8.82892 95.6457 9.08181 95.9581 9.57272C96.1887 9.92974 96.3077 10.5025 96.33 11.3281L96.3375 11.6554H90.5507C89.5837 11.6554 88.8474 11.9157 88.297 12.4438C87.754 12.9719 87.4937 13.7008 87.4937 14.6603V17.0554C87.4937 17.9926 87.7837 18.6992 88.3937 19.2049C88.9515 19.6884 89.7251 19.9339 90.692 19.9339H95.0507C95.9581 19.9339 96.6573 19.6661 97.1705 19.1157C97.6986 18.5653 97.9515 17.8512 97.9515 16.9289V10.2942ZM96.33 16.4678C96.33 17.6355 95.6457 18.2826 94.4036 18.2826H91.1011C90.5581 18.2826 90.0895 18.119 89.7102 17.7917C89.316 17.457 89.1151 17.0033 89.1151 16.4454V15.1438C89.1151 13.8719 89.8143 13.1727 91.0713 13.1727H95.4746C96.2705 13.1727 96.33 13.7454 96.33 13.9165V16.4678Z"
                fill="#F15A29"
              />
              <path
                d="M104.675 7.2372H101.745V2.52893H100.123V19.9265H101.745V8.82893H104.675V7.2372Z"
                fill="#F15A29"
              />
              <path
                d="M117.298 7.23718H115.676V16.2595C115.676 17.1818 115.267 18.2826 113.318 18.2826H110.856C109.986 18.2826 109.406 18.119 109.071 17.7917C108.669 17.3975 108.469 16.8694 108.469 16.2372V7.23718H106.847V16.8917C106.847 18.9669 107.888 19.9264 110.12 19.9264H114.032C116.264 19.9264 117.305 18.9595 117.305 16.8917V7.23718H117.298Z"
                fill="#F15A29"
              />
              <path
                d="M129.957 8.82891C131.571 8.82891 132.01 8.91073 132.203 8.98511C132.739 9.16362 133.379 9.65453 133.379 10.9636V19.9264H135V10.4281C135 9.42395 134.732 8.62065 134.212 8.06279C133.684 7.50494 132.977 7.22974 132.047 7.22974H129.994C128.908 7.22974 128.098 7.63883 127.517 8.47932L127.25 8.8661L126.989 8.47188C126.669 7.98841 126.335 7.66114 125.993 7.49007C125.658 7.31899 125.16 7.22974 124.542 7.22974H122.46C120.414 7.22974 119.455 8.24131 119.455 10.4206V19.919H121.076V10.9636C121.076 9.58759 121.82 8.82891 123.181 8.82891C124.736 8.82891 125.189 8.93304 125.398 9.00742C126.089 9.2975 126.431 9.96693 126.431 11.0082V19.919H128.053V11.0157C128.053 10.3091 128.179 9.81073 128.447 9.49833C128.841 9.05949 129.34 8.82891 129.957 8.82891Z"
                fill="#F15A29"
              />
              <path
                d="M15.9842 3.88267C15.6271 3.62234 15.3891 3.48846 15.0172 3.27275C14.3404 3.0273 13.6114 3.38432 13.3809 4.06862C13.4106 3.97193 14.0875 2.14961 14.1395 1.99341C14.4073 1.26449 15.1883 1.03391 15.761 1.24217C18.1709 2.45457 21.1238 5.16201 21.6891 9.71408C21.6817 10.4504 21.0866 10.986 20.4395 10.9785C20.1941 10.9785 20.0379 10.9785 19.6214 10.9785C19.599 7.73556 17.9329 5.29589 15.9842 3.88267Z"
                fill="#EF4136"
              />
              <path
                d="M15.7837 3.73393L13.4482 10.1529C13.4482 10.1529 13.2102 10.9488 12.273 10.9711C11.4102 10.9711 10.8672 10.9711 10.8672 10.9711C10.8672 10.9711 13.225 4.47773 13.3738 4.07608C13.6788 3.18352 14.5341 3.07195 15.025 3.26534C15.2482 3.39922 15.5383 3.57029 15.7837 3.73393Z"
                fill="url(#paint0_linear_6_4)"
              />
              <path
                d="M20.8564 11.9529C20.3208 11.9529 8.41258 11.9529 8.41258 11.9529C7.76547 11.9677 6.84316 12.1909 6.14399 13.1355C5.35556 14.1991 5.66052 15.419 5.77952 15.7091C5.65308 15.2628 5.80184 14.7421 6.11423 14.452C6.36713 14.2215 6.67209 14.095 6.98448 14.095L20.358 14.0876C21.1242 14.0876 21.4737 13.4405 21.5184 13.3066C21.6225 12.8529 21.7341 11.9826 21.7489 11.6107C21.3919 11.9157 21.087 11.9529 20.8564 11.9529Z"
                fill="#F7941E"
              />
              <path
                d="M7.21489 0.714101C8.18183 0.371952 9.08927 0.208316 9.63224 0.15625C9.63224 0.15625 6.12894 9.75873 6.00249 10.1158C5.70497 10.9414 4.95373 10.986 4.81241 10.986C4.66365 10.986 3.41406 10.986 3.41406 10.986C3.41406 10.986 6.91737 1.36121 6.97687 1.1827C7.05869 0.959556 7.09588 0.8703 7.21489 0.714101Z"
                fill="#808285"
              />
              <path
                d="M13.2842 0.357043C13.2842 0.357043 9.81061 9.90002 9.72136 10.1306C9.60979 10.4356 9.26764 10.9488 8.55359 10.9785C8.1445 10.9785 7.12549 10.9785 7.12549 10.9785C7.12549 10.9785 10.7404 1.04134 10.785 0.952085C10.904 0.602498 11.2685 0.200845 11.8263 0.126465C12.2726 0.156217 12.8974 0.267787 13.2842 0.357043Z"
                fill="#808285"
              />
              <path
                d="M18.6471 15.4564C17.7769 15.4564 8.44216 15.4564 8.44216 15.4564C7.98844 15.4564 7.75042 15.0696 7.75042 14.7795C7.75042 14.4374 8.01819 14.0952 8.44216 14.0952H6.97687C6.58265 14.0952 6.30001 14.2663 6.08431 14.4746C5.70497 14.839 5.63803 15.4266 5.81654 15.8431C6.40414 17.1894 7.57191 17.5985 8.46447 17.5985C9.34216 17.5985 16.4603 17.606 16.4603 17.606C17.0256 17.6283 17.5389 18.0374 17.6504 18.6398C17.7843 19.3613 17.3008 19.7704 17.1372 19.8969C18.0372 19.2646 18.8703 18.4762 19.6215 17.4721C20.2686 16.4977 19.5248 15.4564 18.6471 15.4564Z"
                fill="url(#paint1_linear_6_4)"
              />
              <path
                d="M17.6579 18.6322C17.5686 18.1041 17.1372 17.6876 16.5793 17.6132C12.6744 20.8413 8.77686 19.5471 7.87686 19.2124C6.2405 18.6099 4.84959 17.5835 3.83058 16.1851C2.87107 14.8686 2.46942 13.5446 2.35041 12.9793C2.25372 12.5033 1.82975 11.9231 1.01901 11.9529C0.818182 11.9603 0.453719 12.0124 0 11.6182C0.0966942 13.5 0.743802 15.2107 1.39835 16.3487C3.51074 20.0157 7.08099 21.7562 10.5248 21.8678C10.8074 21.8826 12.2727 21.8975 13.7083 21.5033C15.2405 21.0868 16.4008 20.4173 17.1669 19.8744C17.2636 19.8 17.7843 19.3835 17.6579 18.6322Z"
                fill="url(#paint2_linear_6_4)"
              />
              <path
                d="M5.39265 1.55457C5.39265 1.55457 2.78935 8.65787 2.4472 9.63969C2.20918 10.324 2.08273 10.4653 2.11992 11.2612C1.94885 11.1273 1.72571 10.986 1.30918 10.9711C0.743892 10.9562 0.438933 10.6438 0.305049 10.4653C-0.0296622 10.019 0.059594 9.56531 0.067032 9.49837C0.476123 6.5306 2.16455 3.47357 5.39265 1.55457Z"
                fill="#808285"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_6_4"
                  x1="13.3259"
                  y1="10.9799"
                  x2="13.3259"
                  y2="3.19416"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.00492611" stopColor="#EF4136" />
                  <stop offset="0.4378" stopColor="#EF4136" />
                  <stop offset="0.468" stopColor="#EF4136" />
                  <stop offset="0.5725" stopColor="#EA3F35" />
                  <stop offset="0.6632" stopColor="#E13D33" />
                  <stop offset="0.7487" stopColor="#D4392F" />
                  <stop offset="0.8307" stopColor="#C1332A" />
                  <stop offset="0.8818" stopColor="#B22E25" />
                  <stop offset="0.8985" stopColor="#B22E25" />
                  <stop offset="1" stopColor="#B22E25" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_6_4"
                  x1="6.97016"
                  y1="12.8605"
                  x2="18.4577"
                  y2="19.4929"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0344828" stopColor="#972F1E" />
                  <stop offset="0.0602745" stopColor="#A23B20" />
                  <stop offset="0.2474" stopColor="#F7941E" />
                  <stop offset="1" stopColor="#F7941E" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_6_4"
                  x1="2.93625"
                  y1="19.0322"
                  x2="14.2149"
                  y2="12.5205"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#F7941E" />
                  <stop offset="0.6995" stopColor="#F7941E" />
                  <stop offset="1" stopColor="#972F1E" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className=" w-5/6 ml-auto my-auto md:mt-12 mr-auto sm:flex sm:flex-col  md:hidden h-max    ">
            <div className="relative w-full overflow-hidden h-max">
              <input
                type="checkbox"
                className="peer absolute top-0 inset-x-0 w-full h-12 opacity-0 z-10 "
              ></input>
              <div className="  h-12 w-full  flex items-center justify-start ">
                <div className="text-base font-bold  ">Company</div>
              </div>
              <div className=" absolute top-3 right-3 text-white transition-transform  duration-500 cursor-pointer rotate-0 peer-checked:rotate-180">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="overflow-hidden  text-sm transition-all duration-500 max-h-0 peer-checked:max-h-max  text-gray-600">
                <p
                  className="text-left transition-all duration-500 cursor-pointer  "
                  onClick={() => {
                    navigate("/home");
                  }}
                >
                  Home
                </p>
                <NavHashLink
                  scroll={(el) => scrollWithOffset(el)}
                  smooth
                  to="/home#historySection"
                >
                  {" "}
                  <p className="py-1 text-left transition-all duration-500 cursor-pointer">
                    History
                  </p>
                </NavHashLink>
                <p
                  className="py-1 text-left transition-all duration-500 cursor-pointer"
                  onClick={() => {
                    navigate("/life@netstratum");
                  }}
                >
                  #lifeatnetstratum
                </p>
                <p
                  className="py-1 text-left transition-all duration-500 cursor-pointer"
                  onClick={() => {
                    navigate("/NSEP");
                  }}
                >
                  NSEP
                </p>
                <NavHashLink
                  scroll={(el) => scrollWithOffset(el)}
                  smooth
                  to="/life@netstratum#applyhere"
                >
                  {" "}
                  <p className="py-1 text-left transition-all duration-500 cursor-pointer">
                    Careers
                  </p>
                </NavHashLink>
                {/* <p
                  className="py-1 text-left transition-all duration-500 cursor-pointer"
                  onClick={() => {
                    navigate("/merchandize");
                  }}
                >
                  Merchandize
                </p> */}
                <p
                  className="py-1 text-left transition-all duration-500 cursor-pointer"
                  onClick={() => {
                    navigate("/contact-us");
                  }}
                >
                  Contact
                </p>
                <p
                  className="py-1 text-left transition-all duration-500 cursor-pointer"
                  onClick={() => {
                    navigate("/events");
                  }}
                >
                  Events
                </p>
              </div>
            </div>
            <div className="relative w-full overflow-hidden">
              <input
                type="checkbox"
                className="peer absolute top-0 inset-x-0 w-full h-12 opacity-0 z-10 "
              ></input>
              <div className="  h-12 w-full  flex items-center">
                <div className="text-base font-bold">Expertise</div>
              </div>
              <div className=" absolute top-3 right-3 text-white transition-transform  duration-500 rotate-0 peer-checked:rotate-180">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="overflow-hidden transition-all duration-500 max-h-0 peer-checked:max-h-max text-sm text-gray-600 ">
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/product-development");
                  }}
                >
                  Product Development
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/ai");
                  }}
                >
                  Artificial Intelligence
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/digital-transformation");
                  }}
                >
                  Digital Transformation
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/iot");
                  }}
                >
                  IoT Development
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/it-consulting");
                  }}
                >
                  IT Consulting
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/cloudandintegrations");
                  }}
                >
                  Cloud & Integrations
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/cloudstack");
                  }}
                >
                  Cloudstack
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/finance");
                  }}
                >
                  Finance
                </p>
                <p
                  className="py-1"
                  onClick={() => {
                    navigate("/data-analytics");
                  }}
                >
                  Data Analytics
                </p>
              </div>
              <div className="relative w-full overflow-hidden">
                <input
                  type="checkbox"
                  className="peer absolute top-0 inset-x-0 w-full h-12 opacity-0 z-10 "
                ></input>
                <div className="  h-12 w-full flex items-center">
                  <div className="text-base font-bold">Products</div>
                </div>
                <div className=" absolute top-3 right-3 text-white transition-transform  duration-500 rotate-0 peer-checked:rotate-180">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="overflow-hidden transition-all duration-500 max-h-0 peer-checked:max-h-max text-sm text-gray-600 ">
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#bluemesh"
                  >
                    <p className="py-1 ">Blue Mesh</p>
                  </NavHashLink>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#ncs"
                  >
                    <p className="py-1 ">NCS</p>
                  </NavHashLink>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#hrmnest"
                  >
                    <p className="py-1 ">HRMNest</p>
                  </NavHashLink>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#fohik"
                  >
                    <p className="py-1 ">Fohik</p>
                  </NavHashLink>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#paystratum"
                  >
                    <p className="py-1 ">Paystratum</p>
                  </NavHashLink>
                  {/* <NavHashLink scroll={el => scrollWithOffset(el)} smooth to="/products#smscampaignplatform"><p className='py-1 ' >SMS Campaign Platform</p></NavHashLink> */}
                </div>
              </div>
              <div className="relative w-full overflow-hidden">
                <input
                  type="checkbox"
                  className="peer absolute top-0 inset-x-0 w-full h-12 opacity-0 z-10 "
                ></input>
                <div className="  h-12 w-full flex items-center">
                  <div className="text-base font-bold">Resources</div>
                </div>
                <div className=" absolute top-3 right-3 text-white transition-transform  duration-500 rotate-0 peer-checked:rotate-180">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="overflow-hidden  transition-all duration-500 max-h-0 peer-checked:max-h-max text-sm text-gray-600 ">
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/iot/#usecases"
                  >
                    {" "}
                    <p className="py-1 ">Use cases</p>
                  </NavHashLink>
                  <p
                    className="py-1 "
                    onClick={() => {
                      navigate("/blog");
                    }}
                  >
                    Blog
                  </p>
                  <p
                    className="py-1 "
                    onClick={() => {
                      navigate("/wikipeedika");
                    }}
                  >
                    Wikipeedika
                  </p>
                  <p
                    className="py-1 "
                    onClick={() => {
                      navigate("/privacy-policy");
                    }}
                  >
                    Privacy Policy
                  </p>
                  <p
                    className="py-1 "
                    onClick={() => {
                      navigate("/whitepaper");
                    }}
                  >
                    Whitepaper
                  </p>

                </div>
              </div>
            </div>
          </div>
          <div className=" w-5/6 ml-auto mt-12 mr-auto hidden md:flex md:flex-row   ">
            <div className=" w-[50%]   xl:w-1/3 hidden  lg:justify-between lg:flex lg:flex-col ">
              <svg
                className="flex-shrink-0"
                width="135"
                height="22"
                viewBox="0 0 135 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.4897 8.70245H37.0558C38.9079 8.70245 39.3021 9.75865 39.3021 10.6512V19.8H40.9236V10.0339C40.9236 8.04047 39.9269 7.11072 37.7847 7.11072H33.7682C31.6112 7.11072 30.5996 8.04047 30.5996 10.0339V19.8H32.2211V10.6512C32.2137 9.76609 32.6153 8.70245 34.4897 8.70245Z"
                  fill="#F15A29"
                />
                <path
                  d="M43.0879 16.4975C43.0879 17.7025 43.4152 18.5653 44.092 19.1231C44.6201 19.5694 45.4755 19.8 46.6358 19.8H53.516V18.1487H47.0524C46.316 18.1487 45.7953 18.0223 45.4681 17.7545C44.9995 17.3975 44.7614 16.8025 44.7614 15.9917V15.3818L53.516 11.819V10.3537C53.516 8.13716 52.5342 7.11072 50.4292 7.11072H46.4127C44.1441 7.11072 43.0879 8.09254 43.0879 10.1975V16.4975ZM44.7614 10.7405C44.7614 9.81072 45.178 8.70245 47.1714 8.70245H49.6928C51.5375 8.70245 51.8127 9.84047 51.8127 10.5248V10.9562L44.7614 13.8719V10.7405Z"
                  fill="#F15A29"
                />
                <path
                  d="M60.2337 7.11073H57.3106V2.40247H55.6816V19.8H57.3106V8.70247H60.2337V7.11073Z"
                  fill="#F15A29"
                />
                <path
                  d="M71.8146 16.981V15.3074C71.8146 14.5115 71.5691 13.8719 71.0634 13.3438C70.565 12.8231 69.9402 12.5628 69.1518 12.5628H66.1691C64.384 12.5628 64.0121 11.633 64.0121 10.852V10.3165C64.0121 9.7884 64.2501 9.34212 64.7113 9.02973C65.0311 8.81402 65.4923 8.70245 66.1096 8.70245H71.8072V7.11072H65.4923C64.5625 7.11072 63.8782 7.27435 63.4617 7.60163C62.7402 8.16692 62.3906 8.87353 62.3906 9.77353V11.5587C62.3906 12.3843 62.6881 13.0239 63.3055 13.5149C63.8708 13.9834 64.5997 14.214 65.4774 14.214H68.2964C69.4642 14.214 70.1038 14.8239 70.1038 15.9173C70.1038 16.6611 70.0072 17.1669 69.8138 17.4719C69.546 17.9182 69.0253 18.1487 68.2741 18.1487H62.3981V19.8H68.8989C69.4493 19.8 69.8658 19.7553 70.1336 19.681C70.4386 19.5768 70.7435 19.3463 71.0485 19.0041C71.5691 18.4091 71.8146 17.7396 71.8146 16.981Z"
                  fill="#F15A29"
                />
                <path
                  d="M78.531 7.11073H75.6078V2.40247H73.9863V19.8H75.6078V8.70247H78.531V7.11073Z"
                  fill="#F15A29"
                />
                <path
                  d="M83.418 8.8884C83.5965 8.81402 83.9982 8.72477 85.337 8.70989V7.11072H83.9535C81.737 7.11072 80.7031 8.1446 80.7031 10.3537V19.8H82.3246V10.9487C82.3246 9.86278 82.6891 9.17105 83.418 8.8884Z"
                  fill="#F15A29"
                />
                <path
                  d="M97.952 10.1677C97.952 8.0851 96.8735 7.11072 94.5528 7.11072H87.4941V8.70245H94.2404C95.0735 8.70245 95.6462 8.95535 95.9586 9.44625C96.1892 9.80328 96.3082 10.376 96.3305 11.2016L96.3379 11.5289H90.5512C89.5842 11.5289 88.8479 11.7892 88.2974 12.3173C87.7545 12.8454 87.4941 13.5744 87.4941 14.5339V16.9289C87.4941 17.8661 87.7842 18.5727 88.3941 19.0785C88.952 19.562 89.7255 19.8074 90.6925 19.8074H95.0512C95.9586 19.8074 96.6578 19.5396 97.171 18.9892C97.6991 18.4388 97.952 17.7248 97.952 16.8025V10.1677ZM96.3305 16.3413C96.3305 17.5091 95.6462 18.1562 94.4041 18.1562H91.1016C90.5586 18.1562 90.09 17.9925 89.7107 17.6653C89.3164 17.3306 89.1156 16.8768 89.1156 16.319V15.0173C89.1156 13.7454 89.8148 13.0463 91.0718 13.0463H95.4751C96.271 13.0463 96.3305 13.619 96.3305 13.7901V16.3413Z"
                  fill="#F15A29"
                />
                <path
                  d="M104.675 7.11073H101.745V2.40247H100.123V19.8H101.745V8.70247H104.675V7.11073Z"
                  fill="#F15A29"
                />
                <path
                  d="M117.298 7.11072H115.677V16.133C115.677 17.0553 115.267 18.1562 113.319 18.1562H110.857C109.987 18.1562 109.406 17.9925 109.072 17.6653C108.67 17.271 108.469 16.7429 108.469 16.1107V7.11072H106.848V16.7653C106.848 18.8405 107.889 19.8 110.12 19.8H114.033C116.264 19.8 117.306 18.833 117.306 16.7653V7.11072H117.298Z"
                  fill="#F15A29"
                />
                <path
                  d="M129.958 8.70244C131.572 8.70244 132.01 8.78426 132.204 8.85864C132.739 9.03716 133.379 9.52806 133.379 10.8372V19.8H135.001V10.3016C135.001 9.29749 134.733 8.49418 134.212 7.93633C133.684 7.37848 132.977 7.10327 132.048 7.10327H129.995C128.909 7.10327 128.098 7.51236 127.518 8.35286L127.25 8.73963L126.99 8.34542C126.67 7.86195 126.335 7.53468 125.993 7.3636C125.658 7.19253 125.16 7.10327 124.543 7.10327H122.46C120.415 7.10327 119.455 8.11484 119.455 10.2942V19.7925H121.077V10.8372C121.077 9.46112 121.82 8.70244 123.182 8.70244C124.736 8.70244 125.19 8.80658 125.398 8.88096C126.09 9.17104 126.432 9.84046 126.432 10.8818V19.7925H128.053V10.8892C128.053 10.1826 128.18 9.68426 128.448 9.37187C128.842 8.93302 129.34 8.70244 129.958 8.70244Z"
                  fill="#F15A29"
                />
                <path
                  d="M15.9842 3.75621C15.6271 3.49588 15.3891 3.36199 15.0172 3.14629C14.3404 2.90083 13.6114 3.25786 13.3809 3.94216C13.4106 3.84546 14.0875 2.02315 14.1395 1.86695C14.4073 1.13802 15.1883 0.907446 15.761 1.11571C18.1709 2.32811 21.1238 5.03554 21.6891 9.58761C21.6817 10.324 21.0866 10.8595 20.4395 10.8521C20.1941 10.8521 20.0379 10.8521 19.6214 10.8521C19.599 7.6091 17.9329 5.16943 15.9842 3.75621Z"
                  fill="#EF4136"
                />
                <path
                  d="M15.7837 3.60747L13.4482 10.0265C13.4482 10.0265 13.2102 10.8223 12.273 10.8447C11.4102 10.8447 10.8672 10.8447 10.8672 10.8447C10.8672 10.8447 13.225 4.35127 13.3738 3.94961C13.6788 3.05705 14.5341 2.94548 15.025 3.13887C15.2482 3.27275 15.5383 3.44383 15.7837 3.60747Z"
                  fill="url(#paint0_linear_1951_14999)"
                />
                <path
                  d="M20.8564 11.8265C20.3208 11.8265 8.41258 11.8265 8.41258 11.8265C7.76547 11.8413 6.84316 12.0645 6.14399 13.0091C5.35556 14.0727 5.66052 15.2926 5.77952 15.5827C5.65308 15.1364 5.80184 14.6157 6.11423 14.3256C6.36713 14.0951 6.67209 13.9686 6.98448 13.9686L20.358 13.9612C21.1242 13.9612 21.4737 13.3141 21.5184 13.1802C21.6225 12.7265 21.7341 11.8562 21.7489 11.4843C21.3919 11.7893 21.087 11.8265 20.8564 11.8265Z"
                  fill="#F7941E"
                />
                <path
                  d="M7.21489 0.587636C8.18183 0.245488 9.08927 0.0818513 9.63225 0.0297852C9.63225 0.0297852 6.12894 9.63226 6.00249 9.98929C5.70497 10.8149 4.95373 10.8595 4.81241 10.8595C4.66365 10.8595 3.41406 10.8595 3.41406 10.8595C3.41406 10.8595 6.91737 1.23474 6.97687 1.05623C7.05869 0.833091 7.09588 0.743835 7.21489 0.587636Z"
                  fill="#808285"
                />
                <path
                  d="M13.2837 0.230579C13.2837 0.230579 9.81012 9.77355 9.72087 10.0041C9.6093 10.3091 9.26715 10.8223 8.5531 10.8521C8.14401 10.8521 7.125 10.8521 7.125 10.8521C7.125 10.8521 10.7399 0.914876 10.7845 0.82562C10.9035 0.476033 11.268 0.0743802 11.8258 0C12.2721 0.0297521 12.8969 0.141322 13.2837 0.230579Z"
                  fill="#808285"
                />
                <path
                  d="M18.6476 15.3298C17.7774 15.3298 8.44265 15.3298 8.44265 15.3298C7.98893 15.3298 7.75091 14.9431 7.75091 14.653C7.75091 14.3108 8.01868 13.9687 8.44265 13.9687H6.97736C6.58314 13.9687 6.3005 14.1398 6.08479 14.348C5.70546 14.7125 5.63851 15.3001 5.81703 15.7166C6.40463 17.0629 7.5724 17.472 8.46496 17.472C9.34265 17.472 16.4608 17.4794 16.4608 17.4794C17.0261 17.5017 17.5393 17.9108 17.6509 18.5133C17.7848 19.2348 17.3013 19.6439 17.1377 19.7703C18.0377 19.1381 18.8707 18.3497 19.622 17.3455C20.2691 16.3712 19.5253 15.3298 18.6476 15.3298Z"
                  fill="url(#paint1_linear_1951_14999)"
                />
                <path
                  d="M17.6579 18.5058C17.5686 17.9777 17.1372 17.5612 16.5793 17.4868C12.6744 20.7149 8.77686 19.4207 7.87686 19.086C6.2405 18.4835 4.84959 17.457 3.83058 16.0587C2.87107 14.7422 2.46942 13.4182 2.35041 12.8529C2.25372 12.3769 1.82975 11.7967 1.01901 11.8265C0.818182 11.8339 0.453719 11.886 0 11.4918C0.0966942 13.3736 0.743802 15.0843 1.39835 16.2223C3.51074 19.8893 7.08099 21.6298 10.5248 21.7413C10.8074 21.7562 12.2727 21.7711 13.7083 21.3769C15.2405 20.9604 16.4008 20.2909 17.1669 19.748C17.2636 19.6736 17.7843 19.2571 17.6579 18.5058Z"
                  fill="url(#paint2_linear_1951_14999)"
                />
                <path
                  d="M5.39265 1.4281C5.39265 1.4281 2.78935 8.53141 2.4472 9.51322C2.20918 10.1975 2.08273 10.3388 2.11992 11.1347C1.94885 11.0008 1.72571 10.8595 1.30918 10.8446C0.743892 10.8298 0.438933 10.5174 0.305049 10.3388C-0.0296622 9.89256 0.059594 9.43884 0.067032 9.3719C0.476123 6.40413 2.16455 3.34711 5.39265 1.4281Z"
                  fill="#808285"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_1951_14999"
                    x1="13.3259"
                    y1="10.8535"
                    x2="13.3259"
                    y2="3.0677"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.00492611" stopColor="#EF4136" />
                    <stop offset="0.4378" stopColor="#EF4136" />
                    <stop offset="0.468" stopColor="#EF4136" />
                    <stop offset="0.5725" stopColor="#EA3F35" />
                    <stop offset="0.6632" stopColor="#E13D33" />
                    <stop offset="0.7487" stopColor="#D4392F" />
                    <stop offset="0.8307" stopColor="#C1332A" />
                    <stop offset="0.8818" stopColor="#B22E25" />
                    <stop offset="0.8985" stopColor="#B22E25" />
                    <stop offset="1" stopColor="#B22E25" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_1951_14999"
                    x1="6.97065"
                    y1="12.734"
                    x2="18.4581"
                    y2="19.3663"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.0344828" stopColor="#972F1E" />
                    <stop offset="0.0602745" stopColor="#A23B20" />
                    <stop offset="0.2474" stopColor="#F7941E" />
                    <stop offset="1" stopColor="#F7941E" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_1951_14999"
                    x1="2.93625"
                    y1="18.9058"
                    x2="14.2149"
                    y2="12.394"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#F7941E" />
                    <stop offset="0.6995" stopColor="#F7941E" />
                    <stop offset="1" stopColor="#972F1E" />
                  </linearGradient>
                </defs>
              </svg>
              <div className=" text-[15px]  tracking-normal leading-relaxed hidden lg:contents h-3/6">
                Netstratum offers innovative and excellent IT solutions globally
                with a talented workforce and select partners. We reduce IT
                development costs and increase profit share through high-quality
                software development services and easy access, ensuring
                reliability and convenience with our global presence and time
                zone.
              </div>
              <div className=" flex  justify-start gap-6 sm:flex-col  md:flex-col lg:flex-row md:items-center md:pt-5 mb-5 md:w-full   lg:pt-0    ">
                <svg
                  role="button"
                  onClick={() =>
                    openInNewTab("https://www.facebook.com/netstratum/")
                  }
                  width="34"
                  height="35"
                  className=" flex-shrink-0 sm:w-10 sm:h-10 md:w-8 h-8 "
                  viewBox="0 0 34 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_11_91)">
                    <path
                      d="M21.1885 18.8719L21.6884 15.6144H18.5627V13.5004C18.5627 12.6092 18.9993 11.7405 20.3992 11.7405H21.8202V8.96703C21.8202 8.96703 20.5307 8.74695 19.2978 8.74695C16.7236 8.74695 15.0411 10.3072 15.0411 13.1316V15.6144H12.1797V18.8719H15.0411V26.7469H18.5627V18.8719H21.1885Z"
                      fill="white"
                    />
                  </g>
                  <rect
                    x="0.25"
                    y="0.996948"
                    width="33.5"
                    height="33.5"
                    rx="16.75"
                    stroke="white"
                    strokeWidth="0.5"
                  />
                  <defs>
                    <clipPath id="clip0_11_91">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(8 8.74695)"
                      />
                    </clipPath>
                  </defs>
                </svg>

                <svg
                  role="button"
                  onClick={() =>
                    openInNewTab("https://www.instagram.com/netstratum/")
                  }
                  width="34"
                  height="35"
                  className=" flex-shrink-0 sm:w-10 sm:h-10 md:w-8 h-8"
                  viewBox="0 0 34 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.0037 13.704C14.7678 13.704 12.9643 15.5075 12.9643 17.7435C12.9643 19.9794 14.7678 21.7829 17.0037 21.7829C19.2396 21.7829 21.0432 19.9794 21.0432 17.7435C21.0432 15.5075 19.2396 13.704 17.0037 13.704ZM17.0037 20.3697C15.5588 20.3697 14.3775 19.1919 14.3775 17.7435C14.3775 16.295 15.5553 15.1173 17.0037 15.1173C18.4521 15.1173 19.6299 16.295 19.6299 17.7435C19.6299 19.1919 18.4486 20.3697 17.0037 20.3697ZM22.1506 13.5388C22.1506 14.0626 21.7287 14.481 21.2084 14.481C20.6846 14.481 20.2662 14.0591 20.2662 13.5388C20.2662 13.0185 20.6881 12.5966 21.2084 12.5966C21.7287 12.5966 22.1506 13.0185 22.1506 13.5388ZM24.826 14.495C24.7662 13.2329 24.4779 12.115 23.5533 11.1939C22.6322 10.2728 21.5143 9.9845 20.2521 9.92122C18.9514 9.84739 15.0525 9.84739 13.7518 9.92122C12.4932 9.98098 11.3752 10.2693 10.4506 11.1904C9.52598 12.1115 9.24121 13.2294 9.17793 14.4915C9.1041 15.7923 9.1041 19.6911 9.17793 20.9919C9.2377 22.254 9.52598 23.372 10.4506 24.2931C11.3752 25.2142 12.4896 25.5025 13.7518 25.5657C15.0525 25.6396 18.9514 25.6396 20.2521 25.5657C21.5143 25.506 22.6322 25.2177 23.5533 24.2931C24.4744 23.372 24.7627 22.254 24.826 20.9919C24.8998 19.6911 24.8998 15.7958 24.826 14.495ZM23.1455 22.3876C22.8713 23.0767 22.3404 23.6075 21.6479 23.8853C20.6107 24.2966 18.1498 24.2017 17.0037 24.2017C15.8576 24.2017 13.3932 24.2931 12.3596 23.8853C11.6705 23.6111 11.1396 23.0802 10.8619 22.3876C10.4506 21.3505 10.5455 18.8896 10.5455 17.7435C10.5455 16.5974 10.4541 14.1329 10.8619 13.0993C11.1361 12.4103 11.667 11.8794 12.3596 11.6017C13.3967 11.1904 15.8576 11.2853 17.0037 11.2853C18.1498 11.2853 20.6143 11.1939 21.6479 11.6017C22.3369 11.8759 22.8678 12.4068 23.1455 13.0993C23.5568 14.1365 23.4619 16.5974 23.4619 17.7435C23.4619 18.8896 23.5568 21.354 23.1455 22.3876Z"
                    fill="white"
                  />
                  <rect
                    x="0.25"
                    y="0.996948"
                    width="33.5"
                    height="33.5"
                    rx="16.75"
                    stroke="white"
                    strokeWidth="0.5"
                  />
                </svg>

                <svg
                  width="34"
                  height="35"
                  role="button"
                  onClick={() =>
                    openInNewTab("https://twitter.com/netstratum/")
                  }
                  viewBox="0 0 34 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.25"
                    y="0.996948"
                    width="33.5"
                    height="33.5"
                    rx="16.75"
                    stroke="white"
                    strokeWidth="0.5"
                  />
                  <path
                    d="M21.6829 10.4344H24.1639L18.7437 16.6294L25.1202 25.0594H20.1274L16.2169 19.9467L11.7424 25.0594H9.25993L15.0574 18.4332L8.94043 10.4344H14.0599L17.5947 15.1077L21.6829 10.4344ZM20.8122 23.5744H22.1869L13.3129 11.8414H11.8377L20.8122 23.5744Z"
                    fill="white"
                  />
                </svg>
                <svg
                  role="button"
                  onClick={() =>
                    openInNewTab("https://www.linkedin.com/company/netstratum/")
                  }
                  width="34"
                  height="35"
                  className=" flex-shrink-0 sm:w-10 sm:h-10 md:w-8 h-8"
                  viewBox="0 0 34 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_11_94)">
                    <path
                      d="M12.6505 24.497H9.38516V13.9817H12.6505V24.497ZM11.0161 12.5474C9.97191 12.5474 9.125 11.6825 9.125 10.6384C9.125 10.1368 9.32424 9.65583 9.67888 9.30119C10.0335 8.94655 10.5145 8.74731 11.0161 8.74731C11.5176 8.74731 11.9986 8.94655 12.3532 9.30119C12.7079 9.65583 12.9071 10.1368 12.9071 10.6384C12.9071 11.6825 12.0598 12.5474 11.0161 12.5474ZM24.8715 24.497H21.6132V19.3782C21.6132 18.1583 21.5886 16.5938 19.9155 16.5938C18.2178 16.5938 17.9577 17.9192 17.9577 19.2903V24.497H14.6959V13.9817H17.8276V15.4161H17.8733C18.3092 14.5899 19.3741 13.7181 20.9628 13.7181C24.2675 13.7181 24.875 15.8942 24.875 18.7208V24.497H24.8715Z"
                      fill="white"
                    />
                  </g>
                  <rect
                    x="0.25"
                    y="0.996948"
                    width="33.5"
                    height="33.5"
                    rx="16.75"
                    stroke="white"
                    strokeWidth="0.5"
                  />
                  <defs>
                    <clipPath id="clip0_11_94">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(8 8.74695)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className="flex gap-7 ">
                <div className="flex flex-col  gap-3">
                  <img
                    className="w-12 h-12 rounded-full"
                    src={isologo}
                    alt="ISO"
                  />
                </div>
                <div className="flex flex-col  gap-3">
                  <img
                    className="w-52 h-auto "
                    src={cybersecurity}
                    alt="ISO"
                  />

                </div>


              </div>

            </div>

            <div className=" sm:w-1/4  lg:w-1/5   flex flex-col items-center ">
              <div className="w-max">
                <p className="text-lg text-left font-bold">Company</p>
                <div className="FooterContainer pt-4 flex leading-relaxed flex-col justify-start  text-left text-sm ">
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/home");
                    }}
                  >
                    Home
                  </p>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/home#historySection"
                  >
                    {" "}
                    <p className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer ">
                      History
                    </p>
                  </NavHashLink>
                  <p
                    className=" p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer "
                    onClick={() => {
                      navigate("/life@netstratum");
                    }}
                  >
                    #lifeatnetstratum
                  </p>
                  <p
                    className=" p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer "
                    onClick={() => {
                      navigate("/NSEP");
                    }}
                  >
                    NSEP
                  </p>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/life@netstratum#applyhere"
                  >
                    <p className=" p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer ">
                      Careers
                    </p>
                  </NavHashLink>
                  {/* <p
                    className=" p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer "
                    onClick={() => {
                      navigate("/merchandize");
                    }}
                  >
                    Merchandize
                  </p> */}
                  <p
                    className=" p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer "
                    onClick={() => {
                      navigate("/contact-us");
                    }}
                  >
                    Contact
                  </p>

                  <p
                    className=" p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer "
                    onClick={() => {
                      navigate("/events");
                    }}
                  >
                    Events
                  </p>
                </div>
              </div>
            </div>

            <div className="sm:w-1/4 lg:w-1/5  flex flex-col items-center">
              <div className="w-max flex flex-col justify-evenly">
                <p className="text-lg text-left font-bold">Expertise</p>
                <div className="pt-4 leading-relaxed flex flex-col justify-start  text-left text-sm">
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer   "
                    onClick={() => {
                      navigate("/product-development");
                    }}
                  >
                    Product Development
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer   "
                    onClick={() => {
                      navigate("/ai");
                    }}
                  >
                    Artificial Intelligence
                  </p>

                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/digital-transformation");
                    }}
                  >
                    Digital Transformation
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/iot");
                    }}
                  >
                    IoT Development
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/it-consulting");
                    }}
                  >
                    IT Consulting
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/cloudandintegrations");
                    }}
                  >
                    Cloud & Integrations
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/cloudstack");
                    }}
                  >
                    Cloudstack
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/finance");
                    }}
                  >
                    Finance
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max cursor-pointer  "
                    onClick={() => {
                      navigate("/data-analytics");
                    }}
                  >
                    Data Analytics
                  </p>
                </div>
              </div>
            </div>
            <div className="sm:w-1/4 lg:w-1/5  flex-col flex items-center">
              <div className="w-max flex flex-col justify-evenly">
                <p className="text-lg text-left font-bold">Products</p>
                <div className="pt-4  leading-relaxed flex flex-col justify-start  text-left text-sm">
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#bluemesh"
                  >
                    <p className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer">
                      Blue Mesh
                    </p>
                  </NavHashLink>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#ncs"
                  >
                    {" "}
                    <p className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer">
                      NCS
                    </p>
                  </NavHashLink>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#hrmnest"
                  >
                    <p className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer">
                      HRMNest
                    </p>
                  </NavHashLink>
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#fohik"
                  >
                    <p className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer">
                      Fohik
                    </p>
                  </NavHashLink>

                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/products#paystratum"
                  >
                    <p className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer">
                      Paystratum
                    </p>
                  </NavHashLink>

                  {/* <NavHashLink scroll={el => scrollWithOffset(el)} smooth to="/products#smscampaignplatform"><p className='p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer' >SMS Campaign Platform</p></NavHashLink> */}
                </div>
              </div>
            </div>
            <div className="sm:w-1/4 lg:w-1/5 flex flex-col items-center">
              <div className="w-max flex flex-col justify-evenly">
                <p className="text-lg text-left font-bold">Resources</p>
                <div className="pt-4 leading-relaxed flex flex-col justify-start  text-left text-sm">
                  <NavHashLink
                    scroll={(el) => scrollWithOffset(el)}
                    smooth
                    to="/iot/#usecases"
                  >
                    {" "}
                    <p className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer">
                      Use Cases
                    </p>
                  </NavHashLink>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer "
                    onClick={() => {
                      navigate("/blog");
                    }}
                  >
                    Blog
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer "
                    onClick={() => {
                      navigate("/wikipeedika");
                    }}
                  >
                    Wikipeedika
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer "
                    onClick={() => {
                      navigate("/privacy-policy");
                    }}
                  >
                    Privacy Policy
                  </p>
                  <p
                    className="p-1  border-b-[2px] border-[#000000] hover:border-orange-700 w-max  cursor-pointer "
                    onClick={() => {
                      navigate("/whitepaper");
                    }}
                  >
                    Whitepaper
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className=" flex justify-evenly lg:hidden sm:flex my-7 sm:mt-16 ">
            <svg
              role="button"
              onClick={() =>
                openInNewTab("https://www.facebook.com/netstratum/")
              }
              width="34"
              height="35"
              className=" flex-shrink-0 sm:w-10 sm:h-10"
              viewBox="0 0 34 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_11_91)">
                <path
                  className=""
                  d="M21.1885 18.8719L21.6884 15.6144H18.5627V13.5004C18.5627 12.6092 18.9993 11.7405 20.3992 11.7405H21.8202V8.96703C21.8202 8.96703 20.5307 8.74695 19.2978 8.74695C16.7236 8.74695 15.0411 10.3072 15.0411 13.1316V15.6144H12.1797V18.8719H15.0411V26.7469H18.5627V18.8719H21.1885Z"
                  fill="white"
                />
              </g>
              <rect
                x="0.25"
                y="0.996948"
                width="33.5"
                height="33.5"
                rx="16.75"
                stroke="white"
                strokeWidth="0.5"
              />
              <defs>
                <clipPath id="clip0_11_91">
                  <rect
                    className=""
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(8 8.74695)"
                  />
                </clipPath>
              </defs>
            </svg>
            <svg
              role="button"
              onClick={() =>
                openInNewTab("https://www.instagram.com/netstratum/")
              }
              width="34"
              height="35"
              className=" flex-shrink-0 sm:w-10 sm:h-10 "
              viewBox="0 0 34 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.0037 13.704C14.7678 13.704 12.9643 15.5075 12.9643 17.7435C12.9643 19.9794 14.7678 21.7829 17.0037 21.7829C19.2396 21.7829 21.0432 19.9794 21.0432 17.7435C21.0432 15.5075 19.2396 13.704 17.0037 13.704ZM17.0037 20.3697C15.5588 20.3697 14.3775 19.1919 14.3775 17.7435C14.3775 16.295 15.5553 15.1173 17.0037 15.1173C18.4521 15.1173 19.6299 16.295 19.6299 17.7435C19.6299 19.1919 18.4486 20.3697 17.0037 20.3697ZM22.1506 13.5388C22.1506 14.0626 21.7287 14.481 21.2084 14.481C20.6846 14.481 20.2662 14.0591 20.2662 13.5388C20.2662 13.0185 20.6881 12.5966 21.2084 12.5966C21.7287 12.5966 22.1506 13.0185 22.1506 13.5388ZM24.826 14.495C24.7662 13.2329 24.4779 12.115 23.5533 11.1939C22.6322 10.2728 21.5143 9.9845 20.2521 9.92122C18.9514 9.84739 15.0525 9.84739 13.7518 9.92122C12.4932 9.98098 11.3752 10.2693 10.4506 11.1904C9.52598 12.1115 9.24121 13.2294 9.17793 14.4915C9.1041 15.7923 9.1041 19.6911 9.17793 20.9919C9.2377 22.254 9.52598 23.372 10.4506 24.2931C11.3752 25.2142 12.4896 25.5025 13.7518 25.5657C15.0525 25.6396 18.9514 25.6396 20.2521 25.5657C21.5143 25.506 22.6322 25.2177 23.5533 24.2931C24.4744 23.372 24.7627 22.254 24.826 20.9919C24.8998 19.6911 24.8998 15.7958 24.826 14.495ZM23.1455 22.3876C22.8713 23.0767 22.3404 23.6075 21.6479 23.8853C20.6107 24.2966 18.1498 24.2017 17.0037 24.2017C15.8576 24.2017 13.3932 24.2931 12.3596 23.8853C11.6705 23.6111 11.1396 23.0802 10.8619 22.3876C10.4506 21.3505 10.5455 18.8896 10.5455 17.7435C10.5455 16.5974 10.4541 14.1329 10.8619 13.0993C11.1361 12.4103 11.667 11.8794 12.3596 11.6017C13.3967 11.1904 15.8576 11.2853 17.0037 11.2853C18.1498 11.2853 20.6143 11.1939 21.6479 11.6017C22.3369 11.8759 22.8678 12.4068 23.1455 13.0993C23.5568 14.1365 23.4619 16.5974 23.4619 17.7435C23.4619 18.8896 23.5568 21.354 23.1455 22.3876Z"
                fill="white"
              />
              <rect
                x="0.25"
                y="0.996948"
                width="33.5"
                height="33.5"
                rx="16.75"
                stroke="white"
                strokeWidth="0.5"
              />
            </svg>
            <svg
              width="34"
              height="35"
              role="button"
              onClick={() => openInNewTab("https://twitter.com/netstratum/")}
              viewBox="0 0 34 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.25"
                y="0.996948"
                width="33.5"
                height="33.5"
                rx="16.75"
                stroke="white"
                strokeWidth="0.5"
              />
              <path
                d="M21.6829 10.4344H24.1639L18.7437 16.6294L25.1202 25.0594H20.1274L16.2169 19.9467L11.7424 25.0594H9.25993L15.0574 18.4332L8.94043 10.4344H14.0599L17.5947 15.1077L21.6829 10.4344ZM20.8122 23.5744H22.1869L13.3129 11.8414H11.8377L20.8122 23.5744Z"
                fill="white"
              />
            </svg>
            <svg
              onClick={() =>
                openInNewTab("https://www.linkedin.com/company/netstratum/")
              }
              width="34"
              height="35"
              className=" flex-shrink-0 sm:w-10 sm:h-10 "
              viewBox="0 0 34 35"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_11_94)">
                <path
                  d="M12.6505 24.497H9.38516V13.9817H12.6505V24.497ZM11.0161 12.5474C9.97191 12.5474 9.125 11.6825 9.125 10.6384C9.125 10.1368 9.32424 9.65583 9.67888 9.30119C10.0335 8.94655 10.5145 8.74731 11.0161 8.74731C11.5176 8.74731 11.9986 8.94655 12.3532 9.30119C12.7079 9.65583 12.9071 10.1368 12.9071 10.6384C12.9071 11.6825 12.0598 12.5474 11.0161 12.5474ZM24.8715 24.497H21.6132V19.3782C21.6132 18.1583 21.5886 16.5938 19.9155 16.5938C18.2178 16.5938 17.9577 17.9192 17.9577 19.2903V24.497H14.6959V13.9817H17.8276V15.4161H17.8733C18.3092 14.5899 19.3741 13.7181 20.9628 13.7181C24.2675 13.7181 24.875 15.8942 24.875 18.7208V24.497H24.8715Z"
                  fill="white"
                />
              </g>
              <rect
                x="0.25"
                y="0.996948"
                width="33.5"
                height="33.5"
                rx="16.75"
                stroke="white"
                strokeWidth="0.5"
              />
              <defs>
                <clipPath id="clip0_11_94">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(8 8.74695)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div className="w-full flex  items-center justify-center mb-6 gap-3 lg:hidden  ">
            <img className="w-10 h-10 rounded-full" src={isologo} alt="ISO" />
            <div className="flex flex-col  gap-3">
              <img
                className="w-52 h-auto "
                src={cybersecurity}
                alt="ISO"
              />

            </div>
            {/* <p className="text-xs">ISO 27001:2022 Certified</p> */}
          </div>

        </div>
      ) : (
        <div className="flex flex-col items-center justify-center  max-w-7xl mx-auto ">
          <div className="w-5/6 flex flex-col gap-4 justify-center items-center md:items-start md:justify-start">
            <svg
              width="135"
              height="23"
              viewBox="0 0 135 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M34.4901 9.60248H37.0562C38.9082 9.60248 39.3025 10.6587 39.3025 11.5512V20.7H40.9239V10.9339C40.9239 8.94049 39.9272 8.01074 37.7851 8.01074H33.7686C31.6115 8.01074 30.6 8.94049 30.6 10.9339V20.7H32.2215V11.5512C32.214 10.6661 32.6157 9.60248 34.4901 9.60248Z"
                fill="#F15A29"
              />
              <path
                d="M43.0884 17.3975C43.0884 18.6025 43.4157 19.4653 44.0925 20.0231C44.6206 20.4694 45.476 20.7 46.6363 20.7H53.5165V19.0488H47.0528C46.3165 19.0488 45.7958 18.9223 45.4685 18.6545C44.9999 18.2975 44.7619 17.7025 44.7619 16.8917V16.2818L53.5165 12.719V11.2537C53.5165 9.03719 52.5347 8.01074 50.4297 8.01074H46.4132C44.1446 8.01074 43.0884 8.99256 43.0884 11.0975V17.3975ZM44.7619 11.6405C44.7619 10.7107 45.1785 9.60248 47.1718 9.60248H49.6933C51.538 9.60248 51.8132 10.7405 51.8132 11.4248V11.8562L44.7619 14.7719V11.6405Z"
                fill="#F15A29"
              />
              <path
                d="M60.233 8.01051H57.3098V3.30225H55.6809V20.6998H57.3098V9.60225H60.233V8.01051Z"
                fill="#F15A29"
              />
              <path
                d="M71.8141 17.881V16.2074C71.8141 15.4116 71.5686 14.7719 71.0629 14.2438C70.5645 13.7231 69.9397 13.4628 69.1513 13.4628H66.1686C64.3835 13.4628 64.0116 12.5331 64.0116 11.7521V11.2165C64.0116 10.6884 64.2496 10.2421 64.7108 9.92975C65.0306 9.71405 65.4918 9.60248 66.1091 9.60248H71.8067V8.01074H65.4918C64.562 8.01074 63.8777 8.17438 63.4612 8.50165C62.7397 9.06694 62.3901 9.77355 62.3901 10.6736V12.4587C62.3901 13.2843 62.6877 13.924 63.305 14.4149C63.8703 14.8835 64.5992 15.114 65.4769 15.114H68.2959C69.4637 15.114 70.1034 15.724 70.1034 16.8174C70.1034 17.5612 70.0067 18.0669 69.8133 18.3719C69.5455 18.8182 69.0248 19.0488 68.2736 19.0488H62.3976V20.7H68.8984C69.4488 20.7 69.8653 20.6554 70.1331 20.581C70.4381 20.4769 70.743 20.2463 71.048 19.9041C71.5686 19.3091 71.8141 18.6397 71.8141 17.881Z"
                fill="#F15A29"
              />
              <path
                d="M78.5305 8.01051H75.6073V3.30225H73.9858V20.6998H75.6073V9.60225H78.5305V8.01051Z"
                fill="#F15A29"
              />
              <path
                d="M83.4174 9.78843C83.5959 9.71405 83.9976 9.62479 85.3364 9.60992V8.01074H83.9529C81.7364 8.01074 80.7025 9.04463 80.7025 11.2537V20.7H82.324V11.8488C82.324 10.7628 82.6885 10.0711 83.4174 9.78843Z"
                fill="#F15A29"
              />
              <path
                d="M97.9513 11.0678C97.9513 8.98512 96.8727 8.01074 94.5521 8.01074H87.4934V9.60248H94.2397C95.0727 9.60248 95.6455 9.85537 95.9579 10.3463C96.1884 10.7033 96.3075 11.276 96.3298 12.1017L96.3372 12.4289H90.5504C89.5835 12.4289 88.8471 12.6893 88.2967 13.2174C87.7537 13.7455 87.4934 14.4744 87.4934 15.4339V17.8289C87.4934 18.7661 87.7835 19.4727 88.3934 19.9785C88.9513 20.462 89.7248 20.7074 90.6918 20.7074H95.0504C95.9579 20.7074 96.657 20.4397 97.1703 19.8893C97.6984 19.3388 97.9513 18.6248 97.9513 17.7025V11.0678ZM96.3298 17.2413C96.3298 18.4091 95.6455 19.0562 94.4033 19.0562H91.1008C90.5579 19.0562 90.0893 18.8926 89.7099 18.5653C89.3157 18.2306 89.1149 17.7769 89.1149 17.219V15.9174C89.1149 14.6455 89.8141 13.9463 91.0711 13.9463H95.4744C96.2703 13.9463 96.3298 14.519 96.3298 14.6901V17.2413Z"
                fill="#F15A29"
              />
              <path
                d="M104.675 8.01051H101.745V3.30225H100.123V20.6998H101.745V9.60225H104.675V8.01051Z"
                fill="#F15A29"
              />
              <path
                d="M117.297 8.01074H115.676V17.0331C115.676 17.9554 115.267 19.0562 113.318 19.0562H110.856C109.986 19.0562 109.406 18.8926 109.071 18.5653C108.669 18.1711 108.469 17.643 108.469 17.0107V8.01074H106.847V17.6653C106.847 19.7405 107.888 20.7 110.12 20.7H114.032C116.264 20.7 117.305 19.7331 117.305 17.6653V8.01074H117.297Z"
                fill="#F15A29"
              />
              <path
                d="M129.957 9.60235C131.571 9.60235 132.01 9.68417 132.203 9.75855C132.739 9.93706 133.379 10.428 133.379 11.7371V20.6999H135V11.2015C135 10.1974 134.732 9.39408 134.212 8.83623C133.684 8.27838 132.977 8.00317 132.047 8.00317H129.994C128.908 8.00317 128.098 8.41226 127.517 9.25276L127.25 9.63954L126.989 9.24532C126.669 8.76185 126.335 8.43458 125.993 8.2635C125.658 8.09243 125.16 8.00317 124.542 8.00317H122.46C120.414 8.00317 119.455 9.01474 119.455 11.1941V20.6924H121.076V11.7371C121.076 10.361 121.82 9.60235 123.181 9.60235C124.736 9.60235 125.189 9.70648 125.398 9.78086C126.089 10.0709 126.431 10.7404 126.431 11.7817V20.6924H128.053V11.7891C128.053 11.0825 128.179 10.5842 128.447 10.2718C128.841 9.83293 129.34 9.60235 129.957 9.60235Z"
                fill="#F15A29"
              />
              <path
                d="M15.9843 4.65599C15.6273 4.39566 15.3892 4.26177 15.0173 4.04607C14.3405 3.80061 13.6116 4.15764 13.381 4.84194C13.4107 4.74524 14.0876 2.92293 14.1397 2.76673C14.4074 2.0378 15.1884 1.80723 15.7611 2.01549C18.1711 3.22789 21.124 5.93532 21.6892 10.4874C21.6818 11.2238 21.0868 11.7593 20.4397 11.7519C20.1942 11.7519 20.038 11.7519 19.6215 11.7519C19.5992 8.50888 17.933 6.06921 15.9843 4.65599Z"
                fill="#EF4136"
              />
              <path
                d="M15.7835 4.50725L13.4479 10.9263C13.4479 10.9263 13.2099 11.7221 12.2727 11.7444C11.4099 11.7444 10.8669 11.7444 10.8669 11.7444C10.8669 11.7444 13.2248 5.25105 13.3736 4.84939C13.6785 3.95683 14.5339 3.84526 15.0248 4.03865C15.2479 4.17253 15.538 4.34361 15.7835 4.50725Z"
                fill="url(#paint0_linear_3658_14879)"
              />
              <path
                d="M20.8563 12.7264C20.3207 12.7264 8.41246 12.7264 8.41246 12.7264C7.76535 12.7413 6.84304 12.9644 6.14386 13.9091C5.35543 14.9727 5.66039 16.1925 5.7794 16.4826C5.65296 16.0363 5.80172 15.5157 6.11411 15.2256C6.367 14.995 6.67196 14.8686 6.98436 14.8686L20.3579 14.8611C21.124 14.8611 21.4736 14.214 21.5182 14.0801C21.6224 13.6264 21.7339 12.7562 21.7488 12.3843C21.3918 12.6892 21.0868 12.7264 20.8563 12.7264Z"
                fill="#F7941E"
              />
              <path
                d="M7.21489 1.48754C8.18183 1.14539 9.08927 0.981754 9.63225 0.929688C9.63225 0.929688 6.12894 10.5322 6.00249 10.8892C5.70497 11.7148 4.95373 11.7594 4.81241 11.7594C4.66365 11.7594 3.41406 11.7594 3.41406 11.7594C3.41406 11.7594 6.91737 2.13465 6.97687 1.95613C7.05869 1.73299 7.09588 1.64374 7.21489 1.48754Z"
                fill="#808285"
              />
              <path
                d="M13.2843 1.13048C13.2843 1.13048 9.81073 10.6735 9.72148 10.904C9.60991 11.209 9.26776 11.7222 8.55371 11.752C8.14462 11.752 7.12561 11.752 7.12561 11.752C7.12561 11.752 10.7405 1.81478 10.7851 1.72552C10.9041 1.37594 11.2686 0.974283 11.8264 0.899902C12.2727 0.929654 12.8975 1.04122 13.2843 1.13048Z"
                fill="#808285"
              />
              <path
                d="M18.6471 16.2298C17.7769 16.2298 8.44216 16.2298 8.44216 16.2298C7.98844 16.2298 7.75042 15.843 7.75042 15.5529C7.75042 15.2108 8.01819 14.8687 8.44216 14.8687H6.97687C6.58265 14.8687 6.30001 15.0397 6.08431 15.248C5.70497 15.6125 5.63803 16.2001 5.81654 16.6166C6.40414 17.9629 7.57191 18.372 8.46447 18.372C9.34216 18.372 16.4603 18.3794 16.4603 18.3794C17.0256 18.4017 17.5389 18.8108 17.6504 19.4133C17.7843 20.1348 17.3008 20.5439 17.1372 20.6703C18.0372 20.0381 18.8703 19.2496 19.6215 18.2455C20.2686 17.2711 19.5248 16.2298 18.6471 16.2298Z"
                fill="url(#paint1_linear_3658_14879)"
              />
              <path
                d="M17.6579 19.4057C17.5686 18.8776 17.1372 18.461 16.5793 18.3866C12.6744 21.6147 8.77686 20.3205 7.87686 19.9858C6.2405 19.3833 4.84959 18.3569 3.83058 16.9585C2.87107 15.642 2.46942 14.318 2.35041 13.7528C2.25372 13.2767 1.82975 12.6966 1.01901 12.7263C0.818182 12.7338 0.453719 12.7858 0 12.3916C0.0966942 14.2734 0.743802 15.9842 1.39835 17.1222C3.51074 20.7891 7.08099 22.5296 10.5248 22.6412C10.8074 22.6561 12.2727 22.6709 13.7083 22.2767C15.2405 21.8602 16.4008 21.1908 17.1669 20.6478C17.2636 20.5734 17.7843 20.1569 17.6579 19.4057Z"
                fill="url(#paint2_linear_3658_14879)"
              />
              <path
                d="M5.39253 2.32788C5.39253 2.32788 2.78922 9.43119 2.44708 10.413C2.20906 11.0973 2.08261 11.2386 2.1198 12.0345C1.94873 11.9006 1.72559 11.7593 1.30906 11.7444C0.74377 11.7295 0.438811 11.4171 0.304927 11.2386C-0.0297843 10.7923 0.0594719 10.3386 0.06691 10.2717C0.476001 7.30391 2.16443 4.24689 5.39253 2.32788Z"
                fill="#808285"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_3658_14879"
                  x1="13.3257"
                  y1="11.7532"
                  x2="13.3257"
                  y2="3.96748"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.00492611" stop-color="#EF4136" />
                  <stop offset="0.4378" stop-color="#EF4136" />
                  <stop offset="0.468" stop-color="#EF4136" />
                  <stop offset="0.5725" stop-color="#EA3F35" />
                  <stop offset="0.6632" stop-color="#E13D33" />
                  <stop offset="0.7487" stop-color="#D4392F" />
                  <stop offset="0.8307" stop-color="#C1332A" />
                  <stop offset="0.8818" stop-color="#B22E25" />
                  <stop offset="0.8985" stop-color="#B22E25" />
                  <stop offset="1" stop-color="#B22E25" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_3658_14879"
                  x1="6.97016"
                  y1="13.634"
                  x2="18.4577"
                  y2="20.2663"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0344828" stop-color="#972F1E" />
                  <stop offset="0.0602745" stop-color="#A23B20" />
                  <stop offset="0.2474" stop-color="#F7941E" />
                  <stop offset="1" stop-color="#F7941E" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_3658_14879"
                  x1="2.93625"
                  y1="19.8056"
                  x2="14.2149"
                  y2="13.2939"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#F7941E" />
                  <stop offset="0.6995" stop-color="#F7941E" />
                  <stop offset="1" stop-color="#972F1E" />
                </linearGradient>
              </defs>
            </svg>
            <div className="font-custom text-sm md:text-base md:w-5/6">
              Netstratum Inc is the leading global software development
              provider. Since 2013 , we have collaborated with more than 100+
              high-profile clients worldwide. By working closely with our
              clients, we aim to provide best-in-class software development
              services, help them grow their business, and become trusted
              long-term development partners.
            </div>
            <div className=" flex  justify-start gap-6  lg:flex-row md:items-center md:pt-5 mb-5 md:w-full   lg:pt-0    ">
              <svg
                role="button"
                onClick={() =>
                  openInNewTab("https://www.facebook.com/netstratum/")
                }
                width="34"
                height="35"
                className=" flex-shrink-0 sm:w-10 sm:h-10 md:w-8 h-8 "
                viewBox="0 0 34 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_11_91)">
                  <path
                    d="M21.1885 18.8719L21.6884 15.6144H18.5627V13.5004C18.5627 12.6092 18.9993 11.7405 20.3992 11.7405H21.8202V8.96703C21.8202 8.96703 20.5307 8.74695 19.2978 8.74695C16.7236 8.74695 15.0411 10.3072 15.0411 13.1316V15.6144H12.1797V18.8719H15.0411V26.7469H18.5627V18.8719H21.1885Z"
                    fill="white"
                  />
                </g>
                <rect
                  x="0.25"
                  y="0.996948"
                  width="33.5"
                  height="33.5"
                  rx="16.75"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <defs>
                  <clipPath id="clip0_11_91">
                    <rect
                      width="18"
                      height="18"
                      fill="white"
                      transform="translate(8 8.74695)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <svg
                role="button"
                onClick={() =>
                  openInNewTab("https://www.instagram.com/netstratum/")
                }
                width="34"
                height="35"
                className=" flex-shrink-0 sm:w-10 sm:h-10 md:w-8 h-8"
                viewBox="0 0 34 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.0037 13.704C14.7678 13.704 12.9643 15.5075 12.9643 17.7435C12.9643 19.9794 14.7678 21.7829 17.0037 21.7829C19.2396 21.7829 21.0432 19.9794 21.0432 17.7435C21.0432 15.5075 19.2396 13.704 17.0037 13.704ZM17.0037 20.3697C15.5588 20.3697 14.3775 19.1919 14.3775 17.7435C14.3775 16.295 15.5553 15.1173 17.0037 15.1173C18.4521 15.1173 19.6299 16.295 19.6299 17.7435C19.6299 19.1919 18.4486 20.3697 17.0037 20.3697ZM22.1506 13.5388C22.1506 14.0626 21.7287 14.481 21.2084 14.481C20.6846 14.481 20.2662 14.0591 20.2662 13.5388C20.2662 13.0185 20.6881 12.5966 21.2084 12.5966C21.7287 12.5966 22.1506 13.0185 22.1506 13.5388ZM24.826 14.495C24.7662 13.2329 24.4779 12.115 23.5533 11.1939C22.6322 10.2728 21.5143 9.9845 20.2521 9.92122C18.9514 9.84739 15.0525 9.84739 13.7518 9.92122C12.4932 9.98098 11.3752 10.2693 10.4506 11.1904C9.52598 12.1115 9.24121 13.2294 9.17793 14.4915C9.1041 15.7923 9.1041 19.6911 9.17793 20.9919C9.2377 22.254 9.52598 23.372 10.4506 24.2931C11.3752 25.2142 12.4896 25.5025 13.7518 25.5657C15.0525 25.6396 18.9514 25.6396 20.2521 25.5657C21.5143 25.506 22.6322 25.2177 23.5533 24.2931C24.4744 23.372 24.7627 22.254 24.826 20.9919C24.8998 19.6911 24.8998 15.7958 24.826 14.495ZM23.1455 22.3876C22.8713 23.0767 22.3404 23.6075 21.6479 23.8853C20.6107 24.2966 18.1498 24.2017 17.0037 24.2017C15.8576 24.2017 13.3932 24.2931 12.3596 23.8853C11.6705 23.6111 11.1396 23.0802 10.8619 22.3876C10.4506 21.3505 10.5455 18.8896 10.5455 17.7435C10.5455 16.5974 10.4541 14.1329 10.8619 13.0993C11.1361 12.4103 11.667 11.8794 12.3596 11.6017C13.3967 11.1904 15.8576 11.2853 17.0037 11.2853C18.1498 11.2853 20.6143 11.1939 21.6479 11.6017C22.3369 11.8759 22.8678 12.4068 23.1455 13.0993C23.5568 14.1365 23.4619 16.5974 23.4619 17.7435C23.4619 18.8896 23.5568 21.354 23.1455 22.3876Z"
                  fill="white"
                />
                <rect
                  x="0.25"
                  y="0.996948"
                  width="33.5"
                  height="33.5"
                  rx="16.75"
                  stroke="white"
                  strokeWidth="0.5"
                />
              </svg>
              <svg
                width="34"
                height="35"
                role="button"
                onClick={() => openInNewTab("https://twitter.com/netstratum/")}
                viewBox="0 0 34 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.25"
                  y="0.996948"
                  width="33.5"
                  height="33.5"
                  rx="16.75"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <path
                  d="M21.6829 10.4344H24.1639L18.7437 16.6294L25.1202 25.0594H20.1274L16.2169 19.9467L11.7424 25.0594H9.25993L15.0574 18.4332L8.94043 10.4344H14.0599L17.5947 15.1077L21.6829 10.4344ZM20.8122 23.5744H22.1869L13.3129 11.8414H11.8377L20.8122 23.5744Z"
                  fill="white"
                />
              </svg>
              <svg
                role="button"
                onClick={() =>
                  openInNewTab("https://www.linkedin.com/company/netstratum/")
                }
                width="34"
                height="35"
                className=" flex-shrink-0 sm:w-10 sm:h-10 md:w-8 h-8"
                viewBox="0 0 34 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_11_94)">
                  <path
                    d="M12.6505 24.497H9.38516V13.9817H12.6505V24.497ZM11.0161 12.5474C9.97191 12.5474 9.125 11.6825 9.125 10.6384C9.125 10.1368 9.32424 9.65583 9.67888 9.30119C10.0335 8.94655 10.5145 8.74731 11.0161 8.74731C11.5176 8.74731 11.9986 8.94655 12.3532 9.30119C12.7079 9.65583 12.9071 10.1368 12.9071 10.6384C12.9071 11.6825 12.0598 12.5474 11.0161 12.5474ZM24.8715 24.497H21.6132V19.3782C21.6132 18.1583 21.5886 16.5938 19.9155 16.5938C18.2178 16.5938 17.9577 17.9192 17.9577 19.2903V24.497H14.6959V13.9817H17.8276V15.4161H17.8733C18.3092 14.5899 19.3741 13.7181 20.9628 13.7181C24.2675 13.7181 24.875 15.8942 24.875 18.7208V24.497H24.8715Z"
                    fill="white"
                  />
                </g>
                <rect
                  x="0.25"
                  y="0.996948"
                  width="33.5"
                  height="33.5"
                  rx="16.75"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <defs>
                  <clipPath id="clip0_11_94">
                    <rect
                      width="18"
                      height="18"
                      fill="white"
                      transform="translate(8 8.74695)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-wrap justify-center items-center text-center text-sm mt-5 sm:mt-10 gap-x-6 md:gap-x-10 gap-y-2 max-w-7xl mx-auto px-4">
        {policyRoutes.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className=" py-2 rounded-md font-custom "
          >
            {item.label}
          </Link>
        ))}
      </div>
      <div
        className={`copyRightContainer   text-xs md:text-base h-14 sm:border-t-[1px] ${location?.pathname !== "/lp/mobile-app-development" &&
          location?.pathname !== "/lp/website-development"
          ? "lg:mt-16 "
          : " max-w-[1060px]"
          } border-[#C8C8C8] w-5/6 mx-auto  flex flex-row justify-center items-center`}
      >
        <p>© 2023 Copyright Netstratum Inc. All rights reserved</p>
      </div>
    </div>
  );
};

export default Footer;

// bg-red-600 sm:bg-yellow-600 md:bg-green-700 lg:bg-teal-600
